export const MASTER = 'MASTER';
export const SENDS_ONLY = 'SENDS_ONLY';
